import { tz } from '@date-fns/tz'
import { differenceInCalendarDays, endOfDay, parseISO, startOfDay } from 'date-fns'
import { DEFAULT_TIME_ZONE } from '@/lib/time-zone'

type LocalDateLike = {
  local: string
  timezone?: string | null
}

export const parseLocalDate = ({ local, timezone }: LocalDateLike) =>
  parseISO(local, { in: tz(timezone ?? DEFAULT_TIME_ZONE) })

export const parseLocalDay = (value: string, zone = DEFAULT_TIME_ZONE) =>
  parseISO(value, { in: tz(zone) })

export function normalizeDate(
  value: string | Date | null | undefined,
  zone: string
): Date | null | undefined {
  if (value instanceof Date) return value
  if (typeof value !== 'string') return value
  return value.includes('T')
    ? parseLocalDate({ local: value, timezone: zone })
    : parseLocalDay(value, zone)
}

export const startOfDayInDefaultTimeZone = (date: Date): Date =>
  startOfDay(date, { in: tz(DEFAULT_TIME_ZONE) })

export const endOfDayInDefaultTimeZone = (date: Date): Date =>
  endOfDay(date, { in: tz(DEFAULT_TIME_ZONE) })

// Calendar days on the Berlin calendar: differenceInDays and intervalToDuration().days
// lose a night across the October DST change, and .days also drops whole months.
export const getNightCount = (from: Date, to: Date): number =>
  differenceInCalendarDays(to, from, { in: tz(DEFAULT_TIME_ZONE) })

export const getTodayInDefaultTimeZone = (): Date => startOfDayInDefaultTimeZone(new Date())
